import { cn } from "@carry/ui";

export function ReportSectionTitle({
  label,
  hint,
  className,
}: {
  label: string;
  hint?: string;
  className?: string;
}) {
  return (
    <div className={cn("flex items-baseline justify-between px-1 pb-1.5", className)}>
      <div className="text-[length:var(--fs-xs)] font-semibold uppercase tracking-[.08em] text-[var(--ink-3)]">
        {label}
      </div>
      {hint && <div className="text-[length:var(--fs-xs)] text-[var(--ink-4)]">{hint}</div>}
    </div>
  );
}

export function ReportCard({ children, pad = 14 }: { children: React.ReactNode; pad?: number }) {
  return (
    <div className="rounded-lg bg-[var(--bg-raised)] shadow-sm" style={{ padding: pad }}>
      {children}
    </div>
  );
}

export function ReportRow({ children, last }: { children: React.ReactNode; last?: boolean }) {
  return (
    <div
      className={cn(
        "flex justify-between py-2 text-[length:var(--fs-sm)]",
        last ? "" : "border-b border-[var(--rule-softer)]",
      )}
    >
      {children}
    </div>
  );
}
